import QueueButton from './QueueButton';

export default QueueButton;
